import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, useTemplateRef, watch } from 'vue';
import type { BackgroundAnimation } from './background-animation';
import { retrieveBackgroundAnimation, releaseBackgroundAnimation } from './backgrounds-pool';

type Props = {
  width?: number;
  stopAnimation?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ai-background',
  props: {
    width: { default: 55 },
    stopAnimation: { type: Boolean, default: false }
  },
  setup(__props: any) {



let backgroundAnimationData: BackgroundAnimation | null = null;
const background = useTemplateRef<HTMLElement>('background');

onMounted(() => {
  if (background.value) {
    backgroundAnimationData = retrieveBackgroundAnimation({
      refraction: 0.15,
      offset: 0.18,
      speed: 0.03,
      curvature: 1.0,
      width: __props.width,
      fps: 30
    });
    backgroundAnimationData.attach(background.value);
  }
});

watch(
  () => __props.stopAnimation,
  (value) => {
    if (value) {
      backgroundAnimationData.release();
    }
  }
);

onBeforeUnmount(() => {
  if (backgroundAnimationData) {
    releaseBackgroundAnimation(backgroundAnimationData);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "background",
    ref: background,
    class: _normalizeClass(_ctx.$style.background)
  }, null, 2))
}
}

})